import { render, staticRenderFns } from "./TaxRefund.vue?vue&type=template&id=26452df8&scoped=true"
import script from "./TaxRefund.vue?vue&type=script&lang=js"
export * from "./TaxRefund.vue?vue&type=script&lang=js"
import style0 from "./TaxRefund.vue?vue&type=style&index=0&id=26452df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26452df8",
  null
  
)

export default component.exports